import 'reflect-metadata'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import Vuetify from 'vuetify'
import LongdoMap from 'longdo-map-vue'
import VueSignature from 'vue-signature-pad'
import './plugins/base-components'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

// tslint:disable-next-line:no-var-requires
const VueClipboards = require('vue-clipboard2')

Vue.use(LongdoMap, {
  load: {
    apiKey: process.env.VUE_APP_MAP_KEY,
  },
})

Vue.use(VueClipboards)
Vue.use(VueSignature)
Vue.config.productionTip = false

const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/,
)

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      (fileName
        .split('/')
        .pop() || '')
        .replace(/\.\w+$/, ''),
    ),
  )
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig,
  )
})


Vue.use(Vuetify)
export default new Vuetify({
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    themes: {
      light: {
        primary: '#eb5f47', // #E53935 , '#e8804c'
        secondary: '#073154', // #FFCDD2 , '#86c1a3'
        accent: '#035da6', // #3F51B5 , '#1697b7'
      },
      dark: {
        primary: '#eb5f47', // #E53935 , '#e8804c'
        secondary: '#073154', // #FFCDD2 , '#86c1a3'
        accent: '#035da6', // #3F51B5 , '#1697b7'
      },
    },
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: (h) => h(App),
}).$mount('#app')



